import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { blackColor } from "../../configs/styles/muiThemes";
import { stickyHeader } from "../../utils/styles";
import ProductCommonDetailsTab from "./Tabs/ProductCommonDetailsTab";
import SelectVariantTab from "./Tabs/SelectVariantTab";
import VarianceProductDetailsTab from "./Tabs/VarianceProductDetailsTab";
import VarianceOndcDetailsTab from "./Tabs/VarianceOndcDetailsTab";
import VariantProductPreviewTab from "./Tabs/VariantProductPreviewTab";
import { DEFAULT_COUNTRY } from "../../utils/data";
import { useDispatch, useSelector } from "react-redux";
import {
  countMatch,
  getDefaultProductDetailsTable,
  getOndcDetailsVariantTableHeader,
  getProductCodeLength,
  getProductDetailsTableHeader,
  updateMainProperty,
} from "../../utils/helper";
import {
  mergeValidatedArrays,
  prepareMainVariant,
  preparePreviewVariantData,
  prepareVariantData,
  validateOndcSpecs,
  validateProductDetails,
} from "../../utils/validateAndPrepareVariant";
import { ONDC_DEFAULT_NEW_DATA } from "../../utils/data/defaultFormData";
import { getUnitOfMeasurementApi } from "../../service/api_calls/catalog/CatalogAPI";
import ModalCard from "../../components/ModalCard";
import { useNavigate } from "react-router-dom";
import AlertPopup from "../../components/Alerts/AlertPopup";
import {
  addNewProductChildVariantApi,
  addNewProductVariantApi,
} from "../../service/api_calls/AddVariant/addVariantAPI";
import { clearCatalogData } from "../../reducers/businessPreview/businessPreviewSlice";

function AddProductVariantContent() {
  const [tab, setTab] = useState("product-details");

  const [productInfo, setProductInfo] = useState({
    productName: "",
    brand: "",
    country: DEFAULT_COUNTRY,
    description: "",
    gstPercentage: "",
    refLinks: [{ code: "", link: "" }],

    errors: null,
  });

  const [categoryInfo, setCategoryInfo] = useState({
    ondcEnabled: "yes",
    businessCategory: [],
    ondcCategory: [],
    ondcSubCategory: [],
    selectedBusinessCat: "",
    selectedProductCat: "",
    selectedProductSubCat: "",
    selectedOndcCat: "",
    selectedOndcSubCat: "",

    errors: null,
  });

  const [ondcSpecificationData, setOndcSpecificationData] = useState([]);

  const [selectedVariant, setSelectedVariant] = useState({
    variant1: null,
    variant2: null,
    errors: null,
  });

  const [ondcData, setOndcData] = useState(ONDC_DEFAULT_NEW_DATA);

  const [productCodeList, setProductCodeList] = useState(null);
  const [unitOfMeasurementData, setUnitOfMeasurementData] = useState([]);

  const [previewData, setPreviewData] = useState(null);

  const [errorPageOne, setErrorPageOne] = useState("");
  const [errorPageTwo, setErrorPageTwo] = useState("");
  const [errorPageThree, setErrorPageThree] = useState("");
  const [errorPageFour, setErrorPageFour] = useState("");

  const [tableHeader1, setTableHeader1] = useState(null);
  const [tableHeader2, setTableHeader2] = useState(null);
  const [variantData, setVariantData] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [loader, setLoader] = useState(false);

  const { activeBusinessInfo } = useSelector((state) => state.businessPreview);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSetValue = (name, value, state, setState) => {
    if (name !== "errors") {
      setState((prevState) => ({
        ...prevState,
        [name]: value,
        errors: { ...state?.errors, [name]: "" },
      }));
      return;
    }
    setState({
      ...state,
      [name]: value,
    });
  };

  //handle table cell value change
  const handleValueChange = (key, value, index) => {
    let allVariants = [...variantData];

    const errors = { ...allVariants[index]?.errors };
    delete errors[key];

    if (key === "variant1" || key === "variant2" || key === "variant3") {
      console.log("HITTITIIT");
      allVariants[index] = {
        ...allVariants[index],
        [key]: { ...allVariants[index][key], inputValue: value },
        errors: errors,
      };

      setVariantData(allVariants);

      return;
    }

    if (key === "main") {
      const array = updateMainProperty(allVariants, value, index);
      setVariantData(array);
      return;
    }

    allVariants[index] = {
      ...allVariants[index],
      [key]: value,
      errors: errors,
    };

    console.log("handleValueChange", allVariants[index]);
    setVariantData(allVariants);
  };

  const handleOndcSpecChange = (
    rootIndex,
    specIndex,
    value,
    selector = "inputValue"
  ) => {
    console.log("SpecListData___handleChange_rootIndex", rootIndex);
    console.log("SpecListData___handleChange_specIndex", specIndex);
    console.log("SpecListData___handleChange_value", value);
    console.log("SpecListData___handleChange_selector", selector);

    // Create a shallow copy of the products array
    const newProductList = [...variantData];

    // Create a shallow copy of the specific product object
    const updatedProduct = { ...variantData[rootIndex] };

    // Create a shallow copy of the specList array within the product
    const updatedSpecList = [...updatedProduct.specList];

    // Update the inputValue of the specified specIndex in the updatedSpecList
    updatedSpecList[specIndex] = {
      ...updatedSpecList[specIndex],
      [selector]: value,
      error: value ? "" : updatedSpecList[specIndex]?.error,
    };

    // Update the specList array within the updatedProduct
    updatedProduct.specList = updatedSpecList;

    // // Updating specErrorCount
    // let errorCount = Number(updatedProduct.specErrorCount)
    // if(value){
    //   errorCount = errorCount - 1
    //   updatedProduct.specErrorCount = errorCount
    //   console.log("SpecListData___ERR_COUNT", errorCount);
    // }

    // Update the product within the newProductList
    newProductList[rootIndex] = updatedProduct;

    console.log("SpecListData___handleChange_newProductList", newProductList);

    setVariantData(newProductList);
  };

  const goback = (data) => {
    setTab(data);
    window.scrollTo(0, 0);
  };

  // Get BreadCrumbs List
  const getBreadCrumblinks = () => {
    const businessName = sessionStorage.getItem("costboWEBURL");
    return [
      { label: "Product Catalog", to: `/${businessName}/catalog` },
      { label: "Add Product", to: `#` },
    ];
  };

  const validateTabOne = () => {
    let categoryErr = null;
    let productInfoErr = null;

    console.log("TAB_1_DATA", productInfo, categoryInfo);

    // ONDC categories
    if (categoryInfo?.ondcEnabled === "yes") {
      if (!categoryInfo?.selectedOndcCat) {
        categoryErr = {
          ...categoryErr,
          selectedOndcCat: "Select ONDC category",
        };
      }
      if (!categoryInfo?.selectedOndcSubCat) {
        categoryErr = {
          ...categoryErr,
          selectedOndcSubCat: "Select ONDC sub category",
        };
      }
    }

    // categories
    if (!categoryInfo?.selectedBusinessCat) {
      categoryErr = {
        ...categoryErr,
        selectedBusinessCat: "Select business category",
      };
    }
    if (!categoryInfo?.selectedProductCat) {
      categoryErr = {
        ...categoryErr,
        selectedProductCat: "Select product category",
      };
    }

    // Product Info
    if (!productInfo?.productName) {
      productInfoErr = { ...productInfoErr, productName: "Enter product name" };
    }
    if (!productInfo?.country) {
      productInfoErr = { ...productInfoErr, country: "Select origin" };
    }
    if (!productInfo?.gstPercentage) {
      productInfoErr = {
        ...productInfoErr,
        gstPercentage: "Select GST percentage",
      };
    }
    if (!productInfo?.description) {
      productInfoErr = { ...productInfoErr, description: "Enter description" };
    }

    // Reference Link
    const isRefLinkError = productInfo?.refLinks?.some(
      (item) =>
        (item?.code === "" && item?.link !== "") ||
        (item?.code !== "" && item?.link === "")
    );

    if (isRefLinkError) {
      productInfoErr = {
        ...productInfoErr,
        refLinks: "Enter the label and value",
      };
    }

    if (categoryErr || productInfoErr) {
      setErrorPageOne("Please fix the errors above to proceed");
      if (categoryErr) {
        setCategoryInfo((prevState) => ({
          ...prevState,
          errors: categoryErr,
        }));
      }

      if (productInfoErr) {
        setProductInfo((prevState) => ({
          ...prevState,
          errors: productInfoErr,
        }));
      }
    } else {
      setCategoryInfo((prevState) => ({
        ...prevState,
        errors: null,
      }));

      setProductInfo((prevState) => ({
        ...prevState,
        errors: null,
      }));

      if (categoryInfo?.ondcEnabled !== "yes") {
        setErrorPageOne("Only ONDC enabled products can proceed");
        return;
      }
      setTab("select-variance");
      window.scrollTo(0, 0);
    }
  };

  const validateTabTwo = () => {
    let error = null;
    let ondcErrors = null;
    let pageError = null;

    console.log("selectedVariant", selectedVariant);

    if (!selectedVariant?.variant1) {
      error = {
        ...error,
        variant1: "Select variant 1",
      };
    }
    // if (!selectedVariant?.variant2) {
    //   error = {
    //     ...error,
    //     variant2: "Select variant 2",
    //   };
    // }
    if (!ondcData?.timeToShip || ondcData?.timeToShip == "0") {
      ondcErrors = { ...ondcErrors, timeToShip: "Enter time to ship" };
    }

    if (
      !ondcData?.returnTerms?.returnPeriod ||
      ondcData?.returnTerms?.returnPeriod == "0"
    ) {
      ondcErrors = { ...ondcErrors, returnPeriod: "Enter return period" };
    }

    if (ondcData?.cancelTerms?.cancellable?.toLowerCase() === "yes") {
      if (!ondcData?.cancelTerms?.cancellationFeePercentage) {
        ondcErrors = {
          ...ondcErrors,
          cancellationFeePercentage: "Enter cancellation fee percentage",
        };
      }
      if (
        ondcData?.cancelTerms?.cancellationFeePercentage > 0 &&
        ondcData?.cancelTerms?.cancellationFeePercentage > 100
      ) {
        ondcErrors = {
          ...ondcErrors,
          cancellationFeePercentage:
            "Cancellation fee percentage should be less than or equal to 100",
        };
      }
    }

    if (!ondcData?.productCode?.key) {
      ondcErrors = { ...ondcErrors, productCode1: "Select product code" };
    }

    if (!ondcData?.productCode?.value) {
      ondcErrors = { ...ondcErrors, productCode: "Enter product code" };
    }

    if (ondcData?.productCode?.key && ondcData?.productCode?.value) {
      const productCodeLookup = productCodeList?.find(
        (obj) => obj?.prodictCode === ondcData?.productCode?.key
      );

      let pcError = true;
      productCodeLookup?.validation?.forEach((pattern) => {
        const regex = new RegExp(
          pattern?.replace(/d/g, "\\d")?.replace(/\./g, "\\.")
        );
        if (regex.test(ondcData?.productCode?.value)) {
          pcError = false;
        }
      });

      if (pcError) {
        ondcErrors = {
          ...ondcErrors,
          productCode: `Enter valid ${getProductCodeLength(
            productCodeList,
            ondcData?.productCode?.key
          )} digit product code`,
        };
      }
    }

    if (
      selectedVariant?.variant1?.value?.code !== "uom" &&
      selectedVariant?.variant2?.value?.code !== "uom"
    ) {
      if (!ondcData?.unitOfMeasure?.unit) {
        ondcErrors = {
          ...ondcErrors,
          unitOfMeasure1: "Select Unit of measure",
        };
      }

      if (!ondcData?.unitOfMeasure?.value) {
        ondcErrors = { ...ondcErrors, unitOfMeasure: "Enter Unit of measure" };
      }
    }

    console.log(
      "Hit 0",
      selectedVariant,
      selectedVariant?.variant1 &&
        selectedVariant?.variant2 &&
        !selectedVariant?.variant1?.tag &&
        !selectedVariant?.variant2?.tag,
      selectedVariant?.variant1,
      selectedVariant?.variant2,
      selectedVariant?.variant1?.tag,
      !selectedVariant?.variant2?.tag
    );

    if (
      selectedVariant?.variant1 &&
      !selectedVariant?.variant2 &&
      !selectedVariant?.variant1?.tag
    ) {
      console.log("Hit 1");
      pageError = "Select Min 1 Tag to identify the variant";
    }
    if (
      selectedVariant?.variant1 &&
      selectedVariant?.variant2 &&
      !selectedVariant?.variant1?.tag &&
      !selectedVariant?.variant2?.tag
    ) {
      console.log("Hit 2");
      pageError = "Select Min 1 Tag to identify the variant";
    }

    if (
      selectedVariant?.variant1 &&
      selectedVariant?.variant2 &&
      selectedVariant?.variant1?.value?.value ==
        selectedVariant?.variant2?.value?.value
    ) {
      pageError = "Variant 1 and Variant 2 should be different";
    }

    console.log(
      "TAB_TWO_ERRORS",
      error,
      ondcErrors,
      pageError,
      selectedVariant
    );

    handleSetValue("errors", error, selectedVariant, setSelectedVariant);
    handleSetValue("errors", ondcErrors, ondcData, setOndcData);
    setErrorPageTwo(pageError);

    if (error || pageError || ondcErrors) {
      return;
    }
    console.log(
      "TO_PREPARE_VARIANT_DATA",
      selectedVariant,
      ondcSpecificationData
    );
    setTableHeader1(getProductDetailsTableHeader(selectedVariant));
    setTableHeader2(
      getOndcDetailsVariantTableHeader(selectedVariant, ondcSpecificationData)
    );

    console.log(
      "VARIANT_DATA_5",
      getDefaultProductDetailsTable(
        selectedVariant,
        ondcSpecificationData,
        productInfo?.description,
        productInfo?.gstPercentage,
        ondcData?.productCode
      )
    );
    setVariantData([
      getDefaultProductDetailsTable(
        selectedVariant,
        ondcSpecificationData,
        productInfo?.description,
        productInfo?.gstPercentage,
        ondcData?.productCode
      ),
    ]);

    setTab("variance-product");
  };

  const validateTabThree = () => {
    let isError = false;
    setErrorPageThree(null);

    if (variantData?.length === 0) {
      setErrorPageThree("Add the Variants");
      return;
    }
    const validateProduct = validateProductDetails(
      variantData,
      productCodeList
    );

    const validateOndcProduct = validateOndcSpecs(variantData);

    console.log("VALIDATE_PRODUCT", validateProduct, validateOndcProduct);

    if (variantData?.every((obj) => obj?.main === false)) {
      setErrorPageThree("Select a main variant");
      isError = true;
    }

    if (validateProduct?.isError || validateOndcProduct?.isError) {
      const mergedArray = mergeValidatedArrays(
        validateProduct?.allVariants,
        validateOndcProduct?.allVariants
      );
      setVariantData(mergedArray);
      isError = true;
    }

    if (isError) return;

    const data = preparePreviewVariantData({
      productInfo,
      selectedVariant,
      ondcData,
      variantData,
      tableHeader1,
      tableHeader2,
    });

    setPreviewData(data);

    setTab("product-preview");
  };

  const validateTabFour = () => {
    setErrorPageFour(null);

    if (variantData?.length === 0) {
      setErrorPageFour("Add the Variants in previous page");
      return;
    }
    const validateProduct = validateOndcSpecs(variantData);
    setVariantData(validateProduct?.allVariants);
    if (validateProduct?.isError) return;

    const data = preparePreviewVariantData({
      productInfo,
      selectedVariant,
      ondcData,
      variantData,
      tableHeader1,
      tableHeader2,
    });

    setPreviewData(data);

    setTab("product-preview");
  };

  const addVariantDetails = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    const mainPayload = prepareMainVariant({
      productInfo,
      selectedVariant,
      categoryInfo,
      ondcInfo: ondcData,
      businessInfo: activeBusinessInfo,
    });
    console.log("Main_Variant_Payload", mainPayload);

    setLoader(true);
    const mainRes = await addNewProductVariantApi({
      businessId,
      data: mainPayload,
    });

    console.log("MAIN_VARIANT_RESPONSE", mainRes);

    if (mainRes) {
      const id = mainRes?.productID;

      let childVariantPayload = [];

      variantData?.forEach((variant, index) => {
        const variantPayLoad = prepareVariantData({
          productInfo,
          selectedVariant,
          categoryInfo,
          ondcInfo: ondcData,
          businessInfo: activeBusinessInfo,
          id,
          index,
          variant,
        });
        console.log(`Variant_Payload ${index + 1}`, variantPayLoad);

        childVariantPayload.push(variantPayLoad);

        // const variantRes = await addNewProductVariantApi({
        //   businessId,
        //   data: variantPayLoad,
        // });
        // console.log(`Variant_Response ${index + 1}`, variantRes);
      });

      const childRes = await addNewProductChildVariantApi({
        businessId,
        data: childVariantPayload,
      });
    }
    setLoader(false);
    dispatch(clearCatalogData());
    setShowAlert(true);
  };

  // Get Unit of measurement
  const getUnitsData = async () => {
    const response = await getUnitOfMeasurementApi();
    setUnitOfMeasurementData(() => response?.details || []);
    console.log("getUnitsData:", response);
  };

  const onCopyClick = (data) => {
    setVariantData((prevState) => [...prevState, { ...data, main: false }]);
  };

  const onDeleteClick = (index) => {
    let array = [...variantData];

    if (index > -1) {
      array.splice(index, 1);
    }
    setVariantData(array);
  };

  const handleCancel = () => {
    const webURL = sessionStorage.getItem("costboWEBURL");
    navigate(`/${webURL}/catalog`);
  };

  useEffect(() => {
    if (activeBusinessInfo) {
      setCategoryInfo({
        ...categoryInfo,
        businessCategory: activeBusinessInfo?.businessCategories || [],
        ondcCategory: activeBusinessInfo?.businessONDCCategories || [],
      });
    }
    return () => {};
  }, [activeBusinessInfo]);

  useEffect(() => {
    if (unitOfMeasurementData?.length === 0) {
      getUnitsData();
    }
  }, []);

  return (
    <Box pb={2}>
      <Box
        sx={{
          ...stickyHeader,
          display: { md: "none", xs: "flex" },
          justifyContent: "space-between",
          alignItems: "center",
          pb: { md: 2, xs: 1 },
        }}
      >
        <Typography
          component="h6"
          fontSize={{ xs: 15, md: 17 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 600 }}
          lineHeight="20px"
          display="inline"
        >
          Add Product
        </Typography>
      </Box>
      {tab === "product-details" && (
        <ProductCommonDetailsTab
          title={"Add Product"}
          links={getBreadCrumblinks()}
          onNextClick={validateTabOne}
          onValueChange={handleSetValue}
          productInfo={productInfo}
          setProductInfo={setProductInfo}
          categoryData={categoryInfo}
          setCategoryData={setCategoryInfo}
          setOndcSpecificationData={setOndcSpecificationData}
          setProductCodeList={setProductCodeList}
          pageError={errorPageOne}
          handleCancel={handleCancel}
        />
      )}
      {tab === "select-variance" && (
        <SelectVariantTab
          title={"Add Product"}
          links={getBreadCrumblinks()}
          productInfo={productInfo}
          categoryData={categoryInfo}
          ondcList={ondcSpecificationData}
          selectedVariant={selectedVariant}
          onTagValueChange={(name, value) =>
            handleSetValue(
              name,
              { ...selectedVariant[name], tag: value },
              selectedVariant,
              setSelectedVariant
            )
          }
          onValueChange={(name, value) =>
            handleSetValue(
              name,
              { ...selectedVariant[name], value },
              selectedVariant,
              setSelectedVariant
            )
          }
          ondcData={ondcData}
          setOndcData={setOndcData}
          onOndcValueChange={handleSetValue}
          onNextClick={validateTabTwo}
          onBackClick={() => goback("product-details")}
          pageError={errorPageTwo}
          productCodeList={productCodeList}
          unitOfMeasurementData={unitOfMeasurementData}
          handleCancel={handleCancel}
        />
      )}
      {tab === "variance-product" && (
        <VarianceProductDetailsTab
          title={"Add Product"}
          links={getBreadCrumblinks()}
          productInfo={productInfo}
          categoryData={categoryInfo}
          tableHeader={tableHeader1}
          ondcTableHeader={tableHeader2}
          variantData={variantData}
          onNextClick={validateTabThree}
          productCodeList={productCodeList}
          onBackClick={() => goback("select-variance")}
          handleValueChange={handleValueChange}
          handleChange={handleOndcSpecChange}
          handleAddRow={() =>
            setVariantData((prevState) => [
              ...prevState,
              getDefaultProductDetailsTable(
                selectedVariant,
                ondcSpecificationData,
                productInfo?.description
              ),
            ])
          }
          onCopyClick={onCopyClick}
          onDeleteClick={onDeleteClick}
          handleCancel={handleCancel}
          pageError={errorPageThree}
        />
      )}
      {tab === "variance-ondc" && (
        <VarianceOndcDetailsTab
          title={"Add Product"}
          links={getBreadCrumblinks()}
          productInfo={productInfo}
          categoryData={categoryInfo}
          tableHeader={tableHeader2}
          variantData={variantData}
          pageError={errorPageFour}
          handleChange={handleOndcSpecChange}
          onNextClick={validateTabFour}
          onBackClick={() => goback("variance-product")}
          onDeleteClick={onDeleteClick}
          handleCancel={handleCancel}
        />
      )}
      {tab === "product-preview" && (
        <VariantProductPreviewTab
          title={"Product Detail"}
          links={getBreadCrumblinks()}
          productInfo={productInfo}
          previewData={previewData}
          ondcDetails={previewData?.ondcDetails}
          categoryData={categoryInfo}
          onNextClick={addVariantDetails}
          onBackClick={() => goback("variance-product")}
          loader={loader}
          handleCancel={handleCancel}
        />
      )}

      <ModalCard
        open={showAlert}
        handleClose={() => {
          // setShowAlert(false);
        }}
        width="48%"
      >
        <AlertPopup
          // isLoading={addProductLoader}
          text={`Product Variant added successfully. Our team will review and approve within 24 hours.  New products will be available for customer ordering after approval.\nFor immediate approval, please contact via whatsapp - ‘8088422615’`}
          onClick={() => {
            const webURL = sessionStorage.getItem("costboWEBURL");
            navigate(`/${webURL}/catalogPending`);
          }}
          btnTxt="Go To Catalog"
        />
      </ModalCard>
    </Box>
  );
}

export default AddProductVariantContent;
